const dashboardPage = () => {
  return {
    key: "pageDashboard",
    name: "Dashboard",
    route: "/dashboard",
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

const eventsPage = () => {
  return {
    key: "pageEvents",
    name: "Events",
    route: "/events",
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: true,
  };
};

const performersPage = ({ currentOrganization }) => {
  return {
    key: "pagePerformers",
    name: "Performers",
    route: `/organizations/${currentOrganization?.id}/performers`,
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

const showsPage = ({ currentOrganization }) => {
  return {
    key: "pageShows",
    name: "Shows",
    route: `/organizations/${currentOrganization?.id}/shows`,
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

const roomsPage = ({ currentOrganization }) => {
  return {
    key: "pageRooms",
    name: "Rooms",
    route: `/organizations/${currentOrganization?.id}/rooms`,
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

const ordersPage = () => {
  return {
    key: "pageOrders",
    name: "Orders",
    route: "/orders",
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

const attendeesPage = ({ currentOrganization }) => {
  return {
    key: "pageAttendees",
    name: "Attendees",
    route: `/organizations/${currentOrganization?.id}/attendees`,
    availableToOwner: true,
    availableToAdmin: true,
    availableToScanner: false,
  };
};

export const pages = ({ currentOrganization }) => {
  const { userIsOwner, userIsAdmin, userIsScanner } = currentOrganization || {};

  return [dashboardPage, eventsPage, ordersPage, attendeesPage, showsPage, roomsPage, performersPage]
    .map((pageFn) => pageFn({ currentOrganization }))
    .filter((page) => {
      const { availableToOwner, availableToAdmin, availableToScanner } = page;
      return (
        (availableToOwner && userIsOwner) ||
        (availableToAdmin && userIsAdmin) ||
        (availableToScanner && userIsScanner)
      );
    });
};
